import "./index.scss";

import { MenuItem, Stack } from "@mui/material";
import { ReactComponent as SearchIcon } from "assets/images/icons/search.svg";
import Button from "components/Button";
import Dropdown from "components/Dropdown";
import { STAFF_STATUS_OPTIONS, STAFF_TYPES } from "constants/index";
import _debounce from "lodash/debounce";
import { useCallback } from "react";

const Filter = ({ params, defaultParams, onChange, onClickCreate }) => {
  const onChangeHandler = (e) => {
    let { name, value } = e.target;
    let result = {};
    result[name] = value;
    onChange(result);
  };

  const handleDebounceFn = (inputValue) => {
    onChange({ search: inputValue });
  };

  const debounceFn = useCallback(_debounce(handleDebounceFn, 500), [onChange]);

  return (
    <Stack
      direction="row"
      justifyContent="flex-end"
      mb={1}
      gap="10px"
      className="staff-accounts-list-filter"
    >
      <Dropdown
        name="type"
        label="All Staff Type"
        className="base-dropdown"
        value={params.type}
        defaultValue={defaultParams.type}
        onChange={onChangeHandler}
      >
        {STAFF_TYPES.map((item) => (
          <MenuItem key={item.value} value={item.value}>
            {item.label}
          </MenuItem>
        ))}
      </Dropdown>
      <Dropdown
        name="status"
        label="All Status"
        className="base-dropdown"
        value={params.status}
        defaultValue={defaultParams.status}
        onChange={onChangeHandler}
      >
        {STAFF_STATUS_OPTIONS.map((item) => (
          <MenuItem key={item.value} value={item.value}>
            {item.label}
          </MenuItem>
        ))}
      </Dropdown>
      <Stack direction={"row"} alignItems="center" className="search-with-dropdown-container">
        <SearchIcon className="search-icon" />
        <input placeholder="Search" onChange={(e) => debounceFn(e.target.value)} />
        <Stack height={"90%"} style={{ background: "#d6eeec", width: 1 }} />
        <Dropdown
          name="search_by"
          label="All field"
          className="base-dropdown"
          value={params.search_by}
          defaultValue={defaultParams.search_by}
          onChange={onChangeHandler}
          showLabel={false}
        >
          <MenuItem value="LAST_NAME">Last Name</MenuItem>
          <MenuItem value="FIRST_NAME">First Name</MenuItem>
        </Dropdown>
      </Stack>
      <Button onClick={onClickCreate} label={"Create"} color={"primary-green"} />
    </Stack>
  );
};

export default Filter;
